import {NgModule} from '@angular/core';
import {InputComponent, PlaceholderDirective, HintDirective} from './input.component';
import {TextareaAutosizeDirective} from './textarea-autosize.directive';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {TextMaskModule} from 'angular2-text-mask';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule, FormsModule, NgbTypeaheadModule, TextMaskModule],
    declarations: [PlaceholderDirective, InputComponent, HintDirective, TextareaAutosizeDirective],
    exports: [PlaceholderDirective, InputComponent, HintDirective, TextareaAutosizeDirective],
})
export class InputModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/input/input.module.ts